module.exports = __webpack_public_path__ + "resources/rank_num_9.91ceefdab5eb7620.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/rank_num_9.png
// module id = 548
// module chunks = 0 1 2 3